import React from 'react'
import { Layout } from './Layout'
import type { MetadataProviderProps } from './Context'
import { MetadataProvider } from './Context'

export const MetadataNewInput = (props: Omit<MetadataProviderProps, 'children'>) => {
  return (
    <MetadataProvider {...props}>
      <Layout />
    </MetadataProvider>
  )
}
